import { useId } from 'react';
import { clsx } from 'clsx';

/**
 * Comm360 lockup: the C+ mark, the "Comm360" name and the Juice Plus
 * wordmark beneath it.
 *
 * Drawn inline, not as an `<img>`: an SVG loaded through `<img>` cannot
 * load the wordmark PNG it references, nor use the page's Montserrat.
 * The wordmark is `apps/web/public/juiceplus-wordmark-black.png`; replace
 * that file to change it. The tab icon is `apps/web/public/favicon.svg`.
 *
 * Sizes: `sm` for the top bar, `lg` for the sign-in screen.
 */
export function Logo({ size = 'sm', className }: { size?: 'sm' | 'lg'; className?: string }) {
  const gradientId = `logo-plus-${useId().replace(/[^\w-]/g, '')}`;
  return (
    <svg
      viewBox="0 0 320 100"
      role="img"
      aria-label="Comm360"
      className={clsx('inline-block', size === 'sm' ? 'h-10 w-32' : 'h-16 w-[205px]', className)}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#55799d" />
          <stop offset=".15" stopColor="#55799d" />
          <stop offset=".6" stopColor="#44a779" />
          <stop offset="1" stopColor="#5bc534" />
        </linearGradient>
      </defs>
      <path d="M77.9 30.5 A34 34 0 1 0 77.9 69.5" fill="none" stroke="#000" strokeWidth="16" />
      <g transform="translate(78.05 50.55) scale(0.878125)">
        <path d="M-5-16h10v11h11v10h-11v11h-10v-11h-11v-10h11z" fill={`url(#${gradientId})`} />
      </g>
      <text
        x="116"
        y="58"
        fontFamily="Montserrat, Arial, sans-serif"
        fontWeight="800"
        fontSize="34"
        letterSpacing="-0.7"
        fill="#000"
      >
        Comm360
      </text>
      <image href="/juiceplus-wordmark-black.png" x="117" y="66" width="57.1" height="12" />
    </svg>
  );
}
